import * as Yup from 'yup'

// Not `patient-record-schema.ts`'s `yup.phoneNumberValidator`: that file patches `Yup.string.prototype` globally.
const PHONE_REGEX = /^\+?1?[-.\s]?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/

const phoneSchema = Yup.string()
  .nullable()
  .test('phone', 'Invalid phone number', (value) => !value || PHONE_REGEX.test(value))

export const BASIC_DETAILS_SCHEMA = Yup.object({
  firstname: Yup.string().trim().min(1, 'First name cannot be empty').nullable(),
  lastname: Yup.string().trim().min(1, 'Last name cannot be empty').nullable(),
  preferredName: Yup.string().nullable(),
  // Not `.required()`: the whole card autosaves together, so that would block saving every other field.
  email: Yup.string().lowercase().email().nullable(),
  phone: phoneSchema,
  genderIdentity: Yup.string().nullable(),
  maritalStatus: Yup.string().nullable(),
  source: Yup.string().nullable(),
  birthDate: Yup.string().nullable(),
  isDependent: Yup.boolean().nullable(),
})

export const ETHNICITY_SCHEMA = Yup.object({
  racialIdentities: Yup.array().of(Yup.string()).nullable(),
  otherRacialIdentity: Yup.string().nullable(),
})

export const OCCUPATION_SCHEMA = Yup.object({
  occupation: Yup.string().nullable(),
  employer: Yup.string().nullable(),
})

export const EDUCATION_SCHEMA = Yup.object({
  educationLevel: Yup.string().nullable(),
  otherEducation: Yup.string().nullable(),
})

export const LOCATION_CREDENTIALING_SCHEMA = Yup.object({
  stateOfResidence: Yup.string().nullable(),
})

export const SHIPPING_ADDRESS_SCHEMA = Yup.object({
  street: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  zipCode: Yup.string().nullable(),
})

export const EMERGENCY_CONTACT_SCHEMA = Yup.object({
  name: Yup.string().nullable(),
  phone: phoneSchema,
})

export const BILLING_INFO_SCHEMA = Yup.object({
  memberID: Yup.string().nullable(),
  groupID: Yup.string().nullable(),
  externalReferenceID: Yup.string().nullable(),
  referralType: Yup.string().nullable(),
  referralName: Yup.string().nullable(),
  isFreeRider: Yup.boolean().nullable(),
  excludedFromCalculations: Yup.boolean().nullable(),
})
